import React from "react";

import { Box, Slider, Stack, styled, Typography } from "@mui/material";
import { fontWeight } from "config/Theme/options";
import { useMUIThemeModeContext } from "context/MUIThemeModeContext";
import { renderNumber } from "utils/formatter";

export interface ItemProps {
  title: string;
  url: string;
  max: number;
  done: number;
}

export const XPBarSlider = styled(Slider, {
  shouldForwardProp: (prop) => prop !== "success",
})<{ success?: boolean }>(({ theme, success }) => {
  const { colors } = useMUIThemeModeContext();

  return {
    pointerEvents: "none",
    color: success ? colors["success"] : theme.palette.primary.main,
    height: 7,

    "&.MuiSlider-root": {
      padding: 0,
    },

    "& .MuiSlider-track": {
      boxShadow: "2px 0px 4px 0px rgba(0, 0, 0, 0.1)",
    },
    "& .MuiSlider-rail": {
      backgroundColor: colors.powderBlue,
      opacity: 1,
    },
    "& .MuiSlider-mark": {
      display: "none",
    },
    "& .MuiSlider-thumb": {
      height: 5,
      width: 5,
      marginLeft: -3,
      backgroundColor: colors.white,
      "&:before": {
        boxShadow: "none",
      },
    },
  };
});

const Item: React.FC<ItemProps> = ({ title, url, max, done }) => {
  const { colors } = useMUIThemeModeContext();
  const isDone = done === max;

  const getProgressPercentage = () => {
    if (max === 0) return 0;
    return Math.round((100 * done) / max);
  };

  const handleClick = () => {
    window.location.href = `/atlas#${url}`;
  };

  return (
    <Box width={"100%"} sx={{ cursor: "pointer" }} onClick={handleClick}>
      <Stack direction={"row"} justifyContent={"space-between"}>
        <Typography fontWeight={fontWeight.extraBold} fontFamily={"Nunito"} fontSize={"1rem"}>
          {title}
        </Typography>
        <Typography
          fontFamily={"Nunito"}
          fontWeight={fontWeight.extraBold}
          color={isDone ? colors["success"] : "primary.main"}
          fontSize={"0.875rem"}>
          {`${renderNumber(done)}\u00a0/\u00a0${renderNumber(max)}\u00a0XP`}
        </Typography>
      </Stack>
      <XPBarSlider min={0} max={100} value={getProgressPercentage()} success={isDone} />
    </Box>
  );
};

export default Item;
